import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { ExpandValidity, ExpandValidityState } from './state';
import { createTicketExpandValidity, getExpandValidity, updateTicketExpandValidity } from './thunks';

export const initialState: ExpandValidityState = {
    list: [],
    loading: false,
    pagination: {
        items: 0,
        pages: 0,
        last_page: 0,
        current_page: 1,
    },
};

const expandValidityAdapter = createEntityAdapter<ExpandValidity>({
    selectId: (item) => item.id,
    sortComparer: false,
});

export const expandValiditySlice = createSlice({
    name: 'expand_validity',
    initialState: expandValidityAdapter.getInitialState(),
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getExpandValidity.fulfilled, (state, action) => {
            // Actualiza el estado de la entidad utilizando el adaptador
            expandValidityAdapter.setAll(state, action.payload.expand_validity);
        });
        builder.addCase(createTicketExpandValidity.fulfilled, expandValidityAdapter.updateOne);
        builder.addCase(updateTicketExpandValidity.fulfilled, expandValidityAdapter.updateOne);
    },
});

// Exporta las acciones y el selector del adaptador
export const { selectAll: getAllExpandValidity } = expandValidityAdapter.getSelectors((state: any) => state.expandValidity);

export default expandValiditySlice.reducer;
